// theme/tokens.ts
// Global Design Tokens - Trainova Academy Pro
// All components must reference these tokens.

export const tokens = {
  colors: {
    bg0: "#0F1115",
    bg1: "#151821",
    card: "#1C1F29",
    textPrimary: "rgb(var(--tn-text-e6e8eb))",
    textSecondary: "rgb(var(--tn-text-a9afbc))",
    accent: "#C6A85E", // gold
    success: "#2ECC71",
    warning: "#F39C12",
    danger: "#E74C3C"
  },
  spacing: {
    sectionDesktop: "40px",
    sectionMobile: "24px",
    cardPadding: "20px"
  },
  radius: {
    card: "16px"
  }
};
